import Image from 'next/image'

export default function MemoryMapIcon( { complete } ) {
  // const { bg, fg1, fg2 } = getIconColors( complete )
  
  return (
    <Image width={ 100 } height={ 100 } sizes="100vw" style={ { width: '100%', aspectRatio: '1' } } src={ complete ? '/images/icons/memory-map-colour.png' : '/images/icons/memory-map-grey.png' } alt="Memory map icon" />
  )
}
